import React from 'react';

import './action-modal.scss';
import Icon from '../../../assets/svg-icons';

/**
 * An all-purpose action modal container
 * @param children Child | child[] component(s) child to be rendered inside this modal
 * @param onClose Close model event
 * @param title Title of the modal
 * @param leftPosition Position from the left
 * @returns JSX Element
 */
const ActionModal = ({ onClose, title, leftPosition, ...props }) => {
  const { innerWidth: width } = window;

  const positionRight = (leftPosition + 450) > (width - 60);

  return <>
    <div className="action-modal">
      <div className="action-modal__container" style={positionRight ? { right: '30px' } : { left: `${leftPosition || 0}px` }}>
        <div className="action-modal__header">
          <h3>{title}</h3>
          <button type={'button'} className="action-modal__close" onClick={onClose}><Icon iconName="cross" /></button>
        </div>
        {props.children}
      </div>
    </div>
  </>;
};

export default ActionModal;
